import script from "./HorizontalNavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HorizontalNavMenu.vue?vue&type=script&setup=true&lang=js"

import "./HorizontalNavMenu.vue?vue&type=style&index=0&id=19cb0d96&lang=scss"

const __exports__ = script;

export default __exports__